import ExtraInfoForm from "./extra-info-form";
import AssigneeInfoForm from "./assignee-info-form";
import AssigneeInfoSummary from "./assignee-info-summary";
import ExtraInfoSummary from "./extra-info-summary";
import InterestInfoForm from "./interest-info-form";
import InterestInfoSummary from "./interest-info-summary";

const AssignServiceOrderFormSteps = [
  {
    name: 'Interest Info',
    description: "Information about the customer.",
    accessor: "interestInfo",
    requiresGenerateRAT: false,
    FormComponent: InterestInfoForm,
    SummaryComponent: InterestInfoSummary,
  },
  {
    name: 'Assignee Info',
    description: "Information about the CEWP Agent.",
    accessor: "assigneeInfo",
    requiresGenerateRAT: true,
    FormComponent: AssigneeInfoForm,
    SummaryComponent: AssigneeInfoSummary,
  },
  {
    name: 'Extra Info',
    description: 'Extra information about the appointment.',
    accessor: "extraInfo",
    requiresGenerateRAT: true,
    FormComponent: ExtraInfoForm,
    SummaryComponent: ExtraInfoSummary,
  },
]

export default AssignServiceOrderFormSteps;
